module.exports = __webpack_public_path__ + "static/media/gallery.c6880efd.svg";